// Module
var code = "<div> <span>{{::data.unicode}}</span> <span>{{::data.shortname}}</span> </div> ";
// Exports
module.exports = code;